<template>
  <div class="title-left-table-mode">
    <div class="title-left-table-mode---tool">
      <div class="left">
        <!-- 按执行人 -->
        <el-dropdown @command="handleCommandInfo" size="small" placement="bottom-start" trigger="click" v-if="activeName !== 1">
          <div class="el-dropdown-link">
            <span class="status-change-ele">{{selectInfo}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item) in infoData" :key="item" :command="item">{{item}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 按任务数 -->
        <el-dropdown @command="handleCommandCount" size="small" placement="bottom-start" trigger="click" v-if="!isTaskList">
          <div class="el-dropdown-link">
            <span class="status-change-ele">{{selectCount}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item) in countData" :key="item.value" :command="item">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 任务名字 -->
        <el-dropdown @command="handleCommandTaskList" size="small" placement="bottom-start" trigger="click" v-else>
          <div class="el-dropdown-link">
            <span class="status-change-ele">{{taskSelect}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item) in fliterData" :key="item.task_list_id" :command="item">{{item.title}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 完成状态 -->
        <el-dropdown @command="handleCommandTask" size="small" placement="bottom-start" trigger="click">
          <div class="el-dropdown-link">
            <span class="status-change-ele">{{selectParams.task_stage}}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item) in statusList" :key="item" :command="item">{{item}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import bus from '@/bus'
import tableModeHead from './tableModeHead'
export default {
  components: {
    tableModeHead
  },
  props: {
    projectId: [String, Number],
    tableTemplate: {
      type: Array,
      default: () => []
    },
    taskList: {
      type: Array,
      default: () => []
    },
    activeName: {
      type: Number
    }
  },
  data() {
    return {
      statusList: ['全部', '未完成', '已完成'],
      taskSelect: '所有任务',
      selectParams: {
        id: '',
        index: '',
        sort_method: 'quantity',
        task_stage: '未完成',
      },
      show: false,
      fliterData: [],
      istemplateKeyChange: false,
      infoData: ['按任务清单查看', '按执行人查看'],
      selectInfo: '按任务清单查看',
      selectCount: '按任务数排序',
      countData: [{
        name: '按任务数排序',
        value: 'quantity'
      }, {
        name: '按姓名A-Z排序',
        value: 'name'
      }]
    }
  },
  watch: {
    taskList: {
      handler() {
        this.fliterData = []
        this.fliterData = JSON.parse(JSON.stringify(this.taskList))
        this.fliterData.unshift({
          title: this.taskTip,
          id: '88888'
        })
      },
      deep: true
    }
  },
  computed: {
    isTaskList() {
      return this.selectInfo === '按任务清单查看'
    },
    taskTip() {
      return this.selectInfo === '按任务清单查看' ? '所有任务' : '所有执行人'
    }
  },
  created() {
    bus.$on('fliterInit', () => {
      this.restData()
    })
  },
  mounted() {
    // this.$emit('statusChange', '全部')
  },
  methods: {
    init() {
      this.selectParams.task_stage = '未完成'
      this.taskSelect = this.taskTip
    },
    restData() {
      this.taskSelect = this.taskTip
      this.selectParams = {
        id: '',
        index: '',
        sort_method: '',
        task_stage: '未完成'
      }
      if (!this.isTaskList) {
        this.selectParams.sort_method = 'quantity'
      }
    },
    handleCommandTask(data) {
      this.selectParams.task_stage = data
      this.selectChangeTaskHade()
    },
    handleCommandTaskList(data) {
      if (data.title === this.taskTip) {
        this.taskSelect = data.title
        this.selectParams.id = ''
        this.selectParams.index = ''
        this.selectChangeTaskHade()
        return
      }
      this.taskSelect = data.title
      let index = this.taskList.findIndex(res => res.task_list_id === data.task_list_id)
      this.selectParams.id = this.taskList[index].task_list_id
      this.selectParams.index = index
      this.selectChangeTaskHade()
    },
    selectChangeTaskHade() {
      bus.$emit('selectChangeTaskHade', this.selectParams, !this.isTaskList)
    },
    origin() {
      this.istemplateKeyChange = true
    },
    closePopver() {
      if (this.istemplateKeyChange) {
        this.istemplateKeyChange = false
        this.$emit('templateKeyChange', 1)
      }
    },
    handleCommandInfo(name) {
      if (name === this.selectInfo) return
      this.selectInfo = name
      this.restData()
      this.selectChangeTaskHade()
    },
    handleCommandCount(item) {
      if (this.selectCount === item.name) return
      this.selectParams.id = ''
      this.selectParams.index = ''
      this.selectParams.sort_method = item.value
      this.selectCount = item.name
      this.selectChangeTaskHade()
    }
  }
}
</script>
<style lang="scss">
.title-left-table-mode {
  border-bottom: 1px solid rgba(231, 232, 237, 0.6);
  background-color: #fff;
  .el-dropdown {
    margin-right: 15px;
    i {
      margin-left: 6px;
    }
  }
  .el-dropdown-link {
    color: rgba(32, 32, 32, 0.6);
  }
  .title-left-table-mode---tool {
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
    padding: 0px 30px 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .task-title {
    color: rgba(32, 32, 32, 0.6);
    font-size: 14px;
  }
  .table-autoKey {
    font-size: 14px;
    color: rgba(13, 31, 60, 0.8);
    &:hover {
      cursor: pointer;
    }
    i {
      font-size: 14px;
      color: rgba(13, 31, 60, 0.8);
      margin-right: 10px;
    }
  }
}
</style>
